// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumb-item+.breadcrumb-item[data-v-62994ed8]{padding:0}.breadcrumb-item+.breadcrumb-item[data-v-62994ed8]:before{content:\">\";font-size:15px;display:flex;justify-content:center;padding-right:2px;padding-top:1px}.breadcrumb-item button[data-v-62994ed8]{font-size:12px;color:#000;text-transform:capitalize;font-weight:300px}.breadcrumb-item button[data-v-62994ed8]:hover{color:#007c86}.acting button[data-v-62994ed8]{color:#007c86;cursor:default}", ""]);
// Exports
module.exports = exports;
